import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import checkIcon from './images/ok.svg';

const RadioInput = (props) => {
  const CheckedIcon = props.checkedIcon?.react || props.checkedIcon?.React;
  const hasInlineCheckedIcon = Boolean(CheckedIcon);

  return (
    <div className={`radio-input${hasInlineCheckedIcon ? ' has-inline-checked-icon' : ''}`} style={{'--radio-input-checked-bg-image': checkIcon.bg()}}>
      <input
        onChange={props.onChange}
        checked={props.checked}
        className='radio-custom'
        type='radio'
        id={props.id}
        name={props.name}
        value={props.value}
      />

      <label
        htmlFor={props.id}
        className={`radio-custom-label ${props.id}`}
        style={{
          ...(props.subLabel ? {height: 'unset'} : {}),
        }}
      >
        {hasInlineCheckedIcon && props.checked && (
          <span className='radio-checked-icon' aria-hidden='true'>
            <CheckedIcon />
          </span>
        )}
        {props.image != undefined && <Image src={props.image} alt='logo' className='paymentLogo' />}

        {props.subLabel ? (
          <div className='with-sub-label'>
            {props.label}
            {props.subLabel && <div className='sub-label'>{props.subLabel}</div>}
          </div>
        ) : (
          <>
            <span className='input-label'>{props.label}</span>
          </>
        )}
        {props.price && <span className='price'>{props.price}</span>}
        {props.badge && <div className='item-badge'>{props.badge}</div>}
      </label>
    </div>
  );
};

export default RadioInput;
